if (window.location.pathname.includes("bed-enquiry")) {
  let select =
    localStorage.getItem("createdbed") ||
    JSON.stringify({ "Not Selcted": "wrong Query" });
  const hbinput = document.getElementById("HeadBoardHeightinput");
  const fbinput = document.getElementById("FootBoardHeightinput");
  const slection = JSON.parse(select);
  const key = Object.keys(slection);
  const val = Object.values(slection);
  const keysHtml = key.map((item, i) => {
    return `${key[i]}: ${val[i].option} - £ ${val[i].price}\n`;
  });
  const mainDiv = document.getElementById("selectedOptions");
  mainDiv.innerHTML = keysHtml.join("");
  const hbheight = val[8]?.option;
  const fbheight = val[9]?.option;
  if (!hbheight.includes("Custom")) {
    hbinput.remove();
  }
  if (!fbheight.includes("Custom")) {
    fbinput.remove();
  }
}

(function () {
  emailjs.init("qbqAZeDLKB_GQU_yq");
})();

const submitMail = async (e) => {
  let select =
    localStorage.getItem("createdbed") ||
    JSON.stringify({ "Not Selcted": "wrong Query" });
  const slection = JSON.parse(select);
  const key = Object.keys(slection);
  const val = Object.values(slection);
  const hbheights = val[8]?.option;
  const fbheights = val[9]?.option;
  const username =
    document.getElementById("firstName").value +
    " " +
    document.getElementById("lastName").value;
  const useremail = document.getElementById("email").value;
  const hbheight =
    document.getElementById("HeadBoardHeight")?.value || hbheights;
  const fbheight =
    document.getElementById("FootBoardHeight")?.value || fbheights;
  const options = document.getElementById("selectedOptions").value;
  const phoneNumber = document.getElementById("PhoneNumber")?.value;
  const userMessage = document.getElementById("userMessage")?.value;
  var params = {
    username,
    hbheight: hbheight,
    fbheight,
    phoneNumber,
    userMessage,
    useremail,
    options,
  };
  var serviceID = "service_obqf8d7";
  var templateID = "template_8b34bet";
  emailjs.send(serviceID, templateID, params).then((res) => {
    alert("Mail Sent Sucessfully");
    window.location.href = "https://sleepvillage.co.uk/";
  });
};
